export const charThreshold: number = 3;

export const limitQuerySearch: number = 40;
